import jquery from 'jquery'
import counterup from 'jquery.counterup'
import waypoints from 'waypoints/lib/jquery.waypoints.js'
import dropzone from 'dropzone'
import daterangepicker from 'bootstrap-daterangepicker'
import perfectScrollbar from 'perfect-scrollbar/jquery'
import "metismenu"
import "bootstrap"
import 'perfect-scrollbar/jquery'
import swal from 'sweetalert'

window.$ = window.jQuery = jquery;
window.counterup = counterup;
window.waypoints = waypoints;
window.Dropzone = dropzone;
window.daterangepicker = daterangepicker;
window.swal = swal

perfectScrollbar($)

// Add Dropzone events
window.Dropzone.options.fileUploader = {
    init: function() {
        this.on('success',function(file, response) {
            $(file.previewElement).append(response);
        });
    }
}


require('../../theme/oscarhtml-default/assets/js/theme.js')
